import { type FC, memo } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import styled from 'styled-components'

import BaseModal from 'components/BaseModal'
import { TransactionButton } from 'components/Button/Button'
import Spacer from 'components/Spacer'
import { Body } from 'components/Text'
import { FlexDivCol } from 'components/layout/flex'
import { useAppSelector } from 'state/hooks'
import { selectEmailAddress } from 'state/wallet/selectors'

type Props = {
	onDismiss(): void
}

const EmailVerification: FC<Props> = memo(({ onDismiss }) => {
	const { t } = useTranslation()
	const emailAddress = useAppSelector(selectEmailAddress)

	return (
		<StyledBaseModal title={t('account.email-verification.title')} isOpen onDismiss={onDismiss}>
			<Spacer height={20} />
			<FlexDivCol rowGap="20px">
				<Body size="small" color="secondary">
					<Trans
						i18nKey="account.email-verification.copy"
						components={[<Emphasis key="emphasis" />]}
						values={{ emailAddress }}
					/>
				</Body>
				<MessageContainer>{t('account.email-verification.warning')}</MessageContainer>
				<TransactionButton fullWidth onClick={onDismiss}>
					{t('account.email-verification.close')}
				</TransactionButton>
			</FlexDivCol>
		</StyledBaseModal>
	)
})

const MessageContainer = styled.div`
	color: ${(props) => props.theme.colors.selectedTheme.button.yellow.text};
	flex: none;
	order: 0;
	flex-grow: 0;
	text-align: left;
	font-size: 12px;
	padding: 10px;
	border: 1px solid rgba(239, 104, 104, 0);
	background: ${(props) => props.theme.colors.selectedTheme.button.yellow.fill};
	border-radius: 8px;
	cursor: default;
	white-space: pre-line;
`

const Emphasis = styled.span`
	color: ${(props) => props.theme.colors.selectedTheme.newTheme.text.primary};
	font-weight: 600;
`

const StyledBaseModal = styled(BaseModal)`
	[data-reach-dialog-content] {
		width: 430px;
		margin-top: 300px;
	}
`

export default EmailVerification
